module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"back_button.label":"Voltar"},"en":{"back_button.label":"Back"}}')
  delete Component.options._Ctor
}
